<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col sm="6">
          <div :class="['form-group', isInvalid('fieldName') ? 'has-danger' : '']">
            <label
                    for="customField_fieldName"
                    class="form-control-label">{{$t('views.excmcasetype.form.customField.fieldName')}}:</label>
            <input
                    id="customField_fieldName"
                    v-model="item.fieldName"
                    :class="['form-control', isInvalid('fieldName') ? 'is-invalid' : '']"
                    type="text"
                    :disabled="updated || created"
                    placeholder="">
            <div
                    v-if="isInvalid('fieldName')"
                    class="invalid-feedback">{{ fieldName }}</div>
          </div>
        </b-col>
        <b-col sm="6">
          <div :class="['form-group', isInvalid('fieldLabel') ? 'has-danger' : '']">
            <label
                    for="customField_fieldLabel"
                    class="form-control-label">{{$t('views.excmcasetype.form.customField.fieldLabel')}}:</label>
            <input
                    id="customField_fieldLabel"
                    v-model="item.fieldLabel"
                    :class="['form-control', isInvalid('fieldLabel') ? 'is-invalid' : '']"
                    type="text"
                    :disabled="updated || created"
                    placeholder="">
            <div
                    v-if="isInvalid('fieldLabel')"
                    class="invalid-feedback">{{ fieldLabel }}</div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div :class="['form-group', isInvalid('fieldDescription') ? 'has-danger' : '']">
            <label
                    for="customField_fieldDescription"
                    class="form-control-label">{{$t('views.excmcasetype.form.customField.fieldDescription')}}:</label>
            <textarea id="customField_fieldDescription"
                      v-model="item.fieldDescription"
                      :class="['form-control', isInvalid('fieldDescription') ? 'is-invalid' : '']"
                      type="text"
                      :disabled="updated || created"
                      placeholder=""></textarea>
            <div
                    v-if="isInvalid('fieldDescription')"
                    class="invalid-feedback">{{ fieldDescription }}</div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6" lg="4">
          <div :class="['form-group', isInvalid('fieldType') ? 'has-danger' : '']">
            <label
                    for="customField_fieldType"
                    class="form-control-label">{{$t('views.excmcasetype.form.customField.fieldType')}}:</label>
            <fg-input :error="fieldType">
              <el-select
                      id="excmcasetype_fieldType"
                      :class="['select-default', isInvalid('fieldType') ? 'select-danger' : '']"
                      :placeholder="$t('views.excmcasetype.form.customField.fieldType')"
                      filterable
                      :disabled="updated || created"
                      v-model="item.fieldType">
                <el-option v-for="option in fieldTypes"
                           class="select-default"
                           :value="option['value']"
                           :label="option['name']"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
            <div
                    v-if="isInvalid('fieldType')"
                    class="invalid-feedback">{{ fieldType }}</div>
          </div>
        </b-col>
        <b-col v-if="item.fieldType == 'input'" sm="6" lg="4">
          <div :class="['form-group', isInvalid('fieldDefaultValue') ? 'has-danger' : '']">
            <label
                    for="customField_fieldDefaultValue"
                    class="form-control-label">{{$t('views.excmcasetype.form.customField.fieldDefaultValue')}}:</label>
            <input
                    id="customField_fieldDefaultValue"
                    v-model="item.fieldDefaultValue"
                    :class="['form-control', isInvalid('fieldDefaultValue') ? 'is-invalid' : '']"
                    type="text"
                    :disabled="updated || created"
                    placeholder="">
            <div
                    v-if="isInvalid('fieldDefaultValue')"
                    class="invalid-feedback">{{ fieldDefaultValue }}</div>
          </div>
        </b-col>
        <b-col v-if="item.fieldType === 'inputFormatted'" cols="12">
        <label
          for="customField_fieldDefaultValueFormatted"
          class="form-control-label">{{$t('views.excmcasetype.form.customField.fieldDefaultValue')}}:</label>
          <quill-editor v-model="item.fieldDefaultValue"></quill-editor>
        <div
          v-if="isInvalid('fieldDefaultValue')"
          class="invalid-feedback">{{ fieldDefaultValue }}</div>
        </b-col>
        <b-col sm="6" lg="4">
          <div :class="['form-group', isInvalid('fieldRequired') ? 'has-danger' : '']">
            <label
                    for="customField_fieldRequired"
                    class="form-control-label">{{$t('views.excmcasetype.form.customField.fieldRequired')}}:</label>
            <b-form-group>
              <b-form-radio-group buttons id="customField_fieldRequired" button-variant="outline-primary" :disabled="updated || created" v-model="item.fieldRequired" name="customField_fieldRequired">
                <b-form-radio :value="0" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
                <b-form-radio :value="1" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <div
                    v-if="isInvalid('fieldRequired')"
                    class="invalid-feedback">{{ fieldRequired }}</div>
          </div>
        </b-col>
        <b-col sm="6" lg="4">
          <div :class="['form-group', isInvalid('fieldReadonly') ? 'has-danger' : '']">
            <label
                    for="customField_fieldReadonly"
                    class="form-control-label">{{$t('views.excmcasetype.form.customField.fieldReadonly')}}:</label>
            <b-form-group>
              <b-form-radio-group buttons id="customField_fieldReadonly" button-variant="outline-primary" :disabled="updated || created" v-model="item.fieldReadonly" name="customField_fieldReadonly">
                <b-form-radio :value="0" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
                <b-form-radio :value="1" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <div
                    v-if="isInvalid('fieldReadonly')"
                    class="invalid-feedback">{{ fieldReadonly }}</div>
          </div>
        </b-col>
        <b-col v-if="item.fieldType === 'input'" sm="6" lg="4">
          <div :class="['form-group', isInvalid('onlyNumbersAllowed') ? 'has-danger' : '']">
            <label
              for="customField_onlyNumbersAllowed"
              class="form-control-label">{{$t('views.excmcasetype.form.customField.onlyNumbersAllowed')}}:</label>
            <b-form-group>
              <b-form-radio-group buttons id="customField_onlyNumbersAllowed" button-variant="outline-primary" :disabled="updated || created" v-model="item.onlyNumbersAllowed" name="customField_onlyNumbersAllowed">
                <b-form-radio :value="0" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
                <b-form-radio :value="1" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <div
              v-if="isInvalid('onlyNumbersAllowed')"
              class="invalid-feedback">{{ onlyNumbersAllowed }}</div>
          </div>
        </b-col>
        <b-col v-if="item.fieldType === 'input' && item.onlyNumbersAllowed" sm="6" lg="4">
          <div :class="['form-group', isInvalid('minValue') ? 'has-danger' : '']">
            <label
              for="customField_minValue"
              class="form-control-label">{{$t('views.excmcasetype.form.customField.minValue')}}:</label>
            <input id="customField_minValue"
                   v-model="item.minValue"
                   :class="['form-control', isInvalid('minValue') ? 'is-invalid' : '']"
                   type="number"
                   :disabled="updated || created"
                   placeholder="">
            <div
              v-if="isInvalid('minValue')"
              class="invalid-feedback">{{ minValue }}</div>
          </div>
        </b-col>
        <b-col v-if="item.fieldType === 'input' && item.onlyNumbersAllowed" sm="6" lg="4">
          <div :class="['form-group', isInvalid('maxValue') ? 'has-danger' : '']">
            <label
              for="customField_maxValue"
              class="form-control-label">{{$t('views.excmcasetype.form.customField.maxValue')}}:</label>
            <input id="customField_maxValue"
                   v-model="item.maxValue"
                   :class="['form-control', isInvalid('maxValue') ? 'is-invalid' : '']"
                   type="number"
                   :disabled="updated || created"
                   placeholder="">
            <div
              v-if="isInvalid('maxValue')"
              class="invalid-feedback">{{ maxValue }}</div>
          </div>
        </b-col>
        <b-col v-if="item.fieldType === 'datetime'" sm="6" lg="4">
          <div :class="['form-group', isInvalid('allowedDaysBack') ? 'has-danger' : '']">
            <label
              for="customField_allowedDaysBack"
              class="form-control-label">{{$t('views.excmcasetype.form.customField.allowedDaysBack')}}:</label>
            <input id="customField_allowedDaysBack"
                      v-model="item.allowedDaysBack"
                      :class="['form-control', isInvalid('allowedDaysBack') ? 'is-invalid' : '']"
                      type="number"
                      :disabled="updated || created"
                      placeholder="">
            <div
              v-if="isInvalid('allowedDaysBack')"
              class="invalid-feedback">{{ allowedDaysBack }}</div>
          </div>
        </b-col>
        <b-col v-if="item.fieldType === 'datetime'" sm="6" lg="4">
          <div :class="['form-group', isInvalid('allowedDaysAhead') ? 'has-danger' : '']">
            <label
              for="customField_allowedDaysAhead"
              class="form-control-label">{{$t('views.excmcasetype.form.customField.allowedDaysAhead')}}:</label>
            <input id="customField_allowedDaysAhead"
                      v-model="item.allowedDaysAhead"
                      :class="['form-control', isInvalid('allowedDaysAhead') ? 'is-invalid' : '']"
                      type="number"
                      :disabled="updated || created"
                      placeholder="">
            <div
              v-if="isInvalid('allowedDaysAhead')"
              class="invalid-feedback">{{ allowedDaysAhead }}</div>
          </div>
        </b-col>
        <b-col sm="6" lg="4">
          <div :class="['form-group', isInvalid('showInTable') ? 'has-danger' : '']">
            <label
                    for="customField_showInTable"
                    class="form-control-label">{{$t('views.excmcasetype.form.customField.showInTable')}}:</label>
            <b-form-group>
              <b-form-radio-group buttons id="customField_showInTable" button-variant="outline-primary" :disabled="updated || created" v-model="item.showInTable" name="customField_showInTable">
                <b-form-radio :value="0" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
                <b-form-radio :value="1" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <div
                v-if="isInvalid('showInTable')"
                class="invalid-feedback">{{ showInTable }}</div>
          </div>
        </b-col>
        <b-col sm="6" lg="4" v-if="item.fieldType == 'idUserData'">
          <label>{{ $t('views.excmcasetype.form.customField.idUserDataClientTypes') }}:</label>
          <multi-select :options="roleOptions" :selected-options="idUserDataClientTypes" @select="selectIdUserDataClientTypesHandler"></multi-select>
        </b-col>
      </b-row>
      <b-row v-if="item.fieldType == 'select' || item.fieldType == 'multiSelect'">
        <b-col>
          <b-row>
            <b-col>
              <b-btn v-if="!updated && !created" class="btn btn-success" @click="addNewCustomFieldValue()">{{ $t('views.excmcasetype.form.customField.addNewCustomFieldValue') }}</b-btn>
              <b-btn v-else class="btn btn-disabled">{{ $t('views.excmcasetype.form.customField.addNewCustomFieldValue') }}</b-btn>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-if="item.fieldType == 'datetime'">
      </b-row>
      <b-row>
        <b-col>
          <hr class="my-2">
          <label>{{ $t('views.excmcasetype.form.customField.disabledRoles') }}:</label>
          <multi-select :options="roleOptions" :selected-options="disabledRoles" @select="selectRolesDisabledHandler"></multi-select>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import ApiService from '@/utils/ApiService'
import { MultiSelect } from 'vue-search-select'
import getId from '@/utils/getIdFromLink'
import QuillEditor from '@/components/UIComponents/Inputs/quillEditor.vue'
export default {
  name: 'CustomFieldForm',
  props: {
    item: {
      type: Object,
      required: true
    },
    fieldTypes: {
      type: Array,
      required: true
    }
  },
  components: {
    QuillEditor,
    MultiSelect
  },
  data () {
    return {
      type: '',
      disabledRoles: [],
      idUserDataClientTypes: [],
      roleOptions: [],
      routeName: '',
      fieldType: '',
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btnsDef: {
          // Create a new dropdown
          image: {
            dropdown: ['insertImage'], /*, 'base64' */
            ico: 'insertImage'
          },
          insertText: {
            fn: () => this.insertText(),
            ico: 'blockquote'
          }
        },
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['link'],
          ['image'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['insertText']
        ],
        lang: this.$i18n.locale
      }
    }
  },
  created () {
    this.routeName = this.$route.name
    this.getClientTypes()
  },
  computed: {
    updated () {
      return this.$store.state.excmcustomfield.update.updated
    },
    created () {
      return this.$store.state.excmcustomfield.create.created
    }
  },
  methods: {
    addNewCustomFieldValue () {
      this.$store.state.modals.customFieldValue.create.show = 1
      this.$store.state.modals.customFieldValue.create.parent = this.item
    },
    initialDisabledRoleHandler () {
      if (this.item.disabledRoles) {
        this.disabledRoles = this.item.disabledRoles.map(role => {
          return this.roleOptions.find(option => option.value === role)
        })
      }
    },
    selectRolesDisabledHandler (disabledRoles, lastSelectedDisabledRole) {
      this.disabledRoles = disabledRoles
      this.item.disabledRoles = disabledRoles.map(role => role.value)
      this.lastSelectedDisabledRole = lastSelectedDisabledRole
    },
    initialIdUserDataClientTypesHandler () {
      if (this.item.idUserDataClientTypes) {
        this.idUserDataClientTypes = this.item.idUserDataClientTypes.map(clientType => {
          return this.roleOptions.find(option => option.value === clientType)
        })
      }
    },
    selectIdUserDataClientTypesHandler (idUserDataClientTypes, lastSelectedIdUserDataClientType) {
      this.idUserDataClientTypes = idUserDataClientTypes
      this.item.idUserDataClientTypes = idUserDataClientTypes.map(clientType => clientType.value)
      this.lastSelectedIdUserDataClientType = lastSelectedIdUserDataClientType
    },
    isInvalid (key) {
      // return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    async getClientTypes () {
      let params = { pagination: false }
      const response = await new ApiService('client_types', params).getResults()
      this.roleOptions = response.items.map(entry => {
        return {
          value: getId(entry['@id']),
          text: entry.title
        }
      })
      this.initialDisabledRoleHandler()
      this.initialIdUserDataClientTypesHandler()
    }
  }
}
</script>
